import React from 'react'
import {GROUP_ORDER, GROUP_LABELS} from '../constants'
import {detailLabel, fmN} from '../helpers/format'
import {groupSeries, monthCats} from '../helpers/series'
import StackedBarLine from './charts/StackedBarLine'
import Pareto from './charts/Pareto'
import Legend from './charts/Legend'
import InsightBlock from './sections/InsightBlock'
import NotesBlock from './sections/NotesBlock'

const LABELS = GROUP_ORDER.map(group => GROUP_LABELS[group])

// Tab Report, port từ renderReport() của bản mẫu; thêm khối Chỉ số ngoài sản xuất (BR-08-4)
const ReportView = ({tab, data}) => {
    const months = data.trend_monthly
    const cats = monthCats(months)
    const rateSeries = groupSeries(months, GROUP_ORDER)
    const countSeries = groupSeries(months, GROUP_ORDER, false)
    const paretoItems = data.pareto.map(entry => ({label: detailLabel(entry), value: entry.hits}))
    const outside = data.outside_production

    return (
        <>
            <h2>{tab.label}</h2>
            <p className="sub2">Trang tổng hợp — xu hướng toàn kỳ và nhận định tự sinh</p>

            <div className="sheet">
                <div className="chart-t">NG rate monitoring</div>
                <div className="chart-n">Tỉ lệ lỗi toàn nhà máy theo tháng — cột chồng theo nhóm lỗi · đường và nhãn trên đỉnh là Total</div>
                <StackedBarLine cats={cats} series={rateSeries} aria="NG rate monitoring" xLabel="tháng" target={data.target_rate}/>
                <Legend labels={LABELS} colors={rateSeries.map(s => s.color)} target={data.target_rate}/>
            </div>

            <div className="sheet">
                <div className="g2">
                    <div>
                        <div className="chart-t">NG rate defect by process</div>
                        <div className="chart-n">Tỉ lệ lỗi theo tháng</div>
                        <StackedBarLine cats={cats} series={rateSeries} height={290} aria="tỉ lệ theo tháng" xLabel="tháng"/>
                    </div>
                    <div>
                        <div className="chart-t">Count defect by process</div>
                        <div className="chart-n">Số lỗi theo tháng</div>
                        <StackedBarLine cats={cats} series={countSeries} height={290} pct={false} aria="số lỗi theo tháng" xLabel="tháng"/>
                    </div>
                </div>
                <Legend labels={LABELS} colors={rateSeries.map(s => s.color)}/>
            </div>

            <InsightBlock title="(*) Overall:" lines={data.insights}/>

            {outside && (
                <div className="sheet outside">
                    <div className="blk">Chỉ số ngoài sản xuất</div>
                    <div className="sumline" style={{marginTop: 0, paddingTop: 0, borderTop: 0}}>
                        <span>{outside.label}: <b className="mono">{fmN(outside.hits)}</b> lượt ghi nhận · <b className="mono">{fmN(outside.items)}</b> sản phẩm</span>
                        <span>Không tính vào tỉ lệ lỗi sản xuất</span>
                    </div>
                </div>
            )}

            <div className="sheet">
                <div className="chart-t">Pareto toàn kỳ — chi tiết lỗi</div>
                <div className="chart-n">Cột: tỉ trọng · đường: tích luỹ · ngưỡng 80%</div>
                <Pareto items={paretoItems} total={data.summary.hits} max={14}/>
                <NotesBlock notes={data.notes} warnings={data.warnings} pendingSources={data.pending_sources} outputBasis={data.output_basis}/>
            </div>
        </>
    )
}

export default ReportView
